module.exports = __webpack_public_path__ + "img/line.9c9defa0.svg";